import { render, staticRenderFns } from "./__TemBaoCS.vue?vue&type=template&id=b9ad44f6&"
import script from "./__TemBaoCS.vue?vue&type=script&lang=js&"
export * from "./__TemBaoCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports